import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export function Input({ className, sensitive, ...rest }) {
    return (_jsx("input", { className: classNames(className, "cvr-control", {
            "mm-hide rr-mask data-private mf-masked mf-listen": sensitive,
        }), type: "text", ...rest }));
}
